import request from '../request';

export function getPayUrl(params) {
    return request(`/order`, {
        method: 'POST',
        params
    });
}

export function getStatus(id) {
    return request(`/order/${id}/status`, {
        method: 'GET'
    });
}
